import { IBrazilianStates } from 'entities';
import { SolicitationCancelationStatus } from '../types/enums';

export const ATTACHMENT_TYPE_DESCRIPTIONS = [
  'Anexo',
  'Substabelecimento',
  'Protocolo',
  'Autorização',
  'Petição',
  'Carta de preposição',
  'Contestação',
  'Defesa',
  'Guia',
  'Comprovante',
  'Contrato',
  'Substabelecimento ou Autorização',
];
export const UF_NAMES: { [key: string]: string } = {
  AC: 'Acre',
  AL: 'Alagoas',
  AP: 'Amapá',
  AM: 'Amazonas',
  BA: 'Bahia',
  CE: 'Ceará',
  DF: 'Distrito Federal',
  ES: 'Espírito Santo',
  GO: 'Goiás',
  MA: 'Maranhão',
  MT: 'Mato Grosso',
  MS: 'Mato Grosso do Sul',
  MG: 'Minas Gerais',
  PA: 'Pará',
  PB: 'Paraíba',
  PR: 'Paraná',
  PE: 'Pernambuco',
  PI: 'Piauí',
  RJ: 'Rio de Janeiro',
  RN: 'Rio Grande do Norte',
  RS: 'Rio Grande do Sul',
  RO: 'Rondônia',
  RR: 'Roraima',
  SC: 'Santa Catarina',
  SP: 'São Paulo',
  SE: 'Sergipe',
  TO: 'Tocantins',
};
export const UF_KEYS: { [key: string]: string } = {
  Acre: 'AC',
  Alagoas: 'AL',
  Amapá: 'AP',
  Amazonas: 'AM',
  Bahia: 'BA',
  Ceará: 'CE',
  Distrito_Federal: 'DF',
  Espírito_Santo: 'ES',
  Goiás: 'GO',
  Maranhão: 'MA',
  Mato_Grosso: 'MT',
  Mato_Grosso_do_Sul: 'MS',
  Minas_Gerais: 'MG',
  Pará: 'PA',
  Paraíba: 'PB',
  Paraná: 'PR',
  Pernambuco: 'PE',
  Piauí: 'PI',
  Rio_de_Janeiro: 'RJ',
  Rio_Grande_do_Norte: 'RN',
  Rio_Grande_do_Sul: 'RS',
  Rondônia: 'RO',
  Roraima: 'RR',
  Santa_Catarina: 'SC',
  São_Paulo: 'SP',
  Sergipe: 'SE',
  Tocantins: 'TO',
};
export const UF_NAMES_BY_CODE: { [key: number]: string } = {
  12: 'Acre',
  27: 'Alagoas',
  16: 'Amapá',
  13: 'Amazonas',
  29: 'Bahia',
  23: 'Ceará',
  53: 'Distrito Federal',
  32: 'Espírito Santo',
  52: 'Goiás',
  21: 'Maranhão',
  51: 'Mato Grosso',
  50: 'Mato Grosso do Sul',
  31: 'Minas Gerais',
  15: 'Pará',
  25: 'Paraíba',
  41: 'Paraná',
  26: 'Pernambuco',
  22: 'Piauí',
  33: 'Rio de Janeiro',
  24: 'Rio Grande do Norte',
  43: 'Rio Grande do Sul',
  11: 'Rondônia',
  14: 'Roraima',
  42: 'Santa Catarina',
  35: 'São Paulo',
  28: 'Sergipe',
  17: 'Tocantins',
};
export const UF_BY_CODE: { [key: number]: string } = {
  12: 'AC',
  27: 'AL',
  16: 'AP',
  13: 'AM',
  29: 'BA',
  23: 'CE',
  53: 'DF',
  32: 'ES',
  52: 'GO',
  21: 'MA',
  51: 'MT',
  50: 'MS',
  31: 'MG',
  15: 'PA',
  25: 'PB',
  41: 'PR',
  26: 'PE',
  22: 'PI',
  33: 'RJ',
  24: 'RN',
  43: 'RS',
  11: 'RO',
  14: 'RR',
  42: 'SC',
  35: 'SP',
  28: 'SE',
  17: 'TO',
};
export const UF_CODE_BY_NAME: { [key: string]: number } = {
  AC: 12,
  AL: 27,
  AP: 16,
  AM: 13,
  BA: 29,
  CE: 23,
  DF: 53,
  ES: 32,
  GO: 52,
  MA: 21,
  MT: 51,
  MS: 50,
  MG: 31,
  PA: 15,
  PB: 25,
  PR: 41,
  PE: 26,
  PI: 22,
  RJ: 33,
  RN: 24,
  RS: 43,
  RO: 11,
  RR: 14,
  SC: 42,
  SP: 35,
  SE: 28,
};
export const CANCELATION_REASON_DESCRIPTIONS: {
  id: SolicitationCancelationStatus;
  value: string;
}[] = [
  { id: SolicitationCancelationStatus.OTHER, value: 'Outro' },
  { id: SolicitationCancelationStatus.REASSIGNED_AUDIENCE, value: 'Audiência redesignada' },
  { id: SolicitationCancelationStatus.AUDIENCE_CANCELED, value: 'Audiência cancelada vara' },
  {
    id: SolicitationCancelationStatus.HEARING_WITHDRAWN_FROM_THE_AGENDA,
    value: 'Audiência retirada de pauta',
  },
  {
    id: SolicitationCancelationStatus.DAF_DOES_NOT_CONTRACT,
    value: 'Protocólo aberto em SP - daf não realiza contratação',
  },
  {
    id: SolicitationCancelationStatus.OPEN_PROTOCOL_AS_DUE_DILIGENCE,
    value: 'Protocólo aberto como diligência',
  },
  { id: SolicitationCancelationStatus.OPENED_BY_MISTAKE, value: 'Aberto por equívoco' },
  { id: SolicitationCancelationStatus.WRONGLY_REQUESTED, value: 'Solicitado de forma equivocada' },
  {
    id: SolicitationCancelationStatus.SOLICITATION_CAN_BE_MADE_ONLINE,
    value: 'Solicitação pode ser realizada online',
  },
  { id: SolicitationCancelationStatus.WRONG_OPEN_PROTOCOL, value: 'Protocólo aberto errado' },
  {
    id: SolicitationCancelationStatus.CORRESPONDENT_DOES_NOT_SERVE_THE_LOCATION,
    value: 'Correspondente não atende a localidade',
  },
  {
    id: SolicitationCancelationStatus.DOES_NOT_ACCEPT_THE_TARGETED_OFFERED_VALUE,
    value: 'Não aceita o valor direcionado / ofertado',
  },
  {
    id: SolicitationCancelationStatus.NOT_AVAILABLE_FOR_THE_ACT,
    value: 'Não possui disponibilidade para o ato',
  },
  {
    id: SolicitationCancelationStatus.DOES_NOT_ACCEPT_THE_TERMS_OF_PAYMENT_CONTRACT,
    value: 'Não aceita as condições de pagamento / contrato',
  },
  {
    id: SolicitationCancelationStatus.UNDO_SOLICITATION,
    value: 'Solicitação desfeita',
  },
];
export const MASK_CEP = '99999-999';
export const MASK_CPF = '999.999.999-99';
export const MASK_NUMBER_ADDRESS = '99999';
export const MASK_PHONE = '(99) 99999-9999';
export const MASK_CNPJ = '99.999.999/9999-99';
export const MASK_PROCESS_NUMBER = '9999999-99.9999.9.99.9999';

export const BRAZILIAN_STATES: IBrazilianStates[] = [
  { ufCode: 27, name: 'Alagoas' },
  { ufCode: 12, name: 'Acre' },
  { ufCode: 16, name: 'Amapá' },
  { ufCode: 13, name: 'Amazonas' },
  { ufCode: 29, name: 'Bahia' },
  { ufCode: 23, name: 'Ceará' },
  { ufCode: 53, name: 'Distrito Federal' },
  { ufCode: 32, name: 'Espírito Santo' },
  { ufCode: 52, name: 'Goiás' },
  { ufCode: 21, name: 'Maranhão' },
  { ufCode: 51, name: 'Mato Grosso' },
  { ufCode: 50, name: 'Mato Grosso do Sul' },
  { ufCode: 31, name: 'Minas Gerais' },
  { ufCode: 41, name: 'Paraná' },
  { ufCode: 25, name: 'Paraíba' },
  { ufCode: 15, name: 'Pará' },
  { ufCode: 26, name: 'Pernambuco' },
  { ufCode: 22, name: 'Piauí' },
  { ufCode: 24, name: 'Rio Grande do Norte' },
  { ufCode: 43, name: 'Rio Grande do Sul' },
  { ufCode: 33, name: 'Rio de Janeiro' },
  { ufCode: 11, name: 'Rondônia' },
  { ufCode: 14, name: 'Roraima' },
  { ufCode: 42, name: 'Santa Catarina' },
  { ufCode: 28, name: 'Sergipe' },
  { ufCode: 35, name: 'São Paulo' },
  { ufCode: 17, name: 'Tocantins' },
];

export const LOCALE_TRANSLATE_JOYRIDE : Record<string, string> = {
  back: 'Voltar',
  close: 'Fechar',
  last: 'Finalizar',
  next: 'Próximo',
  skip: 'Pular',
  nextLabelWithProgress: 'Próximo (Passo {step} de {steps})',
  open: 'Abrir',
}; 
